"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "containerElement", "lg", "md", "size", "sm", "xl", "xs"];
/**
 * SPDX-FileCopyrightText: © 2020 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
/* eslint-disable @liferay/no-abbreviations */

var Col = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classNames;
  var children = _ref.children,
    className = _ref.className,
    _ref$containerElement = _ref.containerElement,
    ContainerElement = _ref$containerElement === void 0 ? 'div' : _ref$containerElement,
    lg = _ref.lg,
    md = _ref.md,
    size = _ref.size,
    sm = _ref.sm,
    xl = _ref.xl,
    xs = _ref.xs,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var noBreakPoints = !lg && !md && !sm && !xs && !xl && !size;
  xs = xs || size;
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, (_classNames = {
      col: noBreakPoints,
      'col-lg': lg === true
    }, _defineProperty(_classNames, "col-lg-".concat(lg), lg && typeof lg !== 'boolean'), _defineProperty(_classNames, 'col-md', md === true), _defineProperty(_classNames, "col-md-".concat(md), md && typeof md !== 'boolean'), _defineProperty(_classNames, 'col-sm', sm === true), _defineProperty(_classNames, "col-sm-".concat(sm), sm && typeof sm !== 'boolean'), _defineProperty(_classNames, "col-".concat(xs), xs && typeof xs !== 'boolean'), _defineProperty(_classNames, 'col-xl', xl === true), _defineProperty(_classNames, "col-xl-".concat(xl), xl && typeof xl !== 'boolean'), _classNames)),
    ref: ref
  }), children);
});
Col.displayName = 'ClayCol';
var _default = exports.default = Col;